import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import SweetAlert from 'react-bootstrap-sweetalert';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';

import { createDmxUniverse, getDmxUniversesByController } from '../../store/actions';

class CreateDmxUniverseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      popup: false,
      pop_msg: null,
      pop_err: null,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { messageDmxUniverse, createDmxUniverseError, loadingCreateDmxUniverse } = this.props;
    if (loadingCreateDmxUniverse === false && prevProps.loadingCreateDmxUniverse === true) {
      if (messageDmxUniverse) {
        this.setState({ popup: true, pop_msg: 'Universo creado correctamente' });
        this.props.getDmxUniversesByController(this.state.user, this.props.controllerId);
      } else if (createDmxUniverseError) {
        this.setState({ popup: true, pop_err: createDmxUniverseError.message || 'No se ha podido crear el universo' });
      }
    }
  }

  handleValidSubmit(event, values) {
    const user = this.state.user;
    values.controller_id = this.props.controllerId;
    values.universe_number = Number(values.universe_number);
    values.channel_count = Number(values.channel_count) || 512;
    values.token = user.token;
    this.props.createDmxUniverse(values);
  }

  render() {
    return (
      <>
        <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
          <Row>
            <Col md="3">
              <FormGroup>
                <Label htmlFor="universeNumber">{this.props.t('Nuevo universo (número)')}</Label>
                <AvField
                  name="universe_number"
                  type="number"
                  className="form-control"
                  validate={{ required: { value: true } }}
                  id="universeNumber"
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label htmlFor="universeChannelCount">{this.props.t('Canales')}</Label>
                <AvField
                  name="channel_count"
                  type="number"
                  className="form-control"
                  value={512}
                  id="universeChannelCount"
                />
              </FormGroup>
            </Col>
            <Col md="3" className="d-flex align-items-end">
              <FormGroup>
                <Button color="secondary" type="submit">
                  {this.props.t('Añadir universo')}
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </AvForm>
        {this.state.popup ? (
          <SweetAlert
            type={this.state.pop_msg ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.pop_msg ? 'success' : 'danger'}
            title={this.state.pop_msg ? this.state.pop_msg : this.state.pop_err}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.setState({ popup: false })}
          ></SweetAlert>
        ) : null}
      </>
    );
  }
}

const mapStateprops = (state) => {
  const { createDmxUniverseError, messageDmxUniverse, loadingCreateDmxUniverse } = state.createDmxUniverse;
  return { createDmxUniverseError, messageDmxUniverse, loadingCreateDmxUniverse };
};

export default withRouter(
  connect(mapStateprops, { createDmxUniverse, getDmxUniversesByController })(withNamespaces()(CreateDmxUniverseForm)),
);
